import styled from '@emotion/styled';

import COLORS from '$variables/colors';
import { spacing, breakpoints } from '$variables/theme';

// eslint-disable-next-line import/prefer-default-export
export const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px ${spacing.medium};
  border-bottom: 1px solid ${COLORS.grey};
`;

export const RightDecorationDesktop = styled.div`
  display: flex;
  margin-left: ${spacing.xSmall};

  @media (max-width: ${breakpoints.small}) {
    display: none;
  }
`;
